import { parseMoney } from './money';

export const parseShippingFee = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  const text = String(value).trim();
  if (/free\s*shipping/i.test(text)) return 0;
  if (/^(₦|NGN)?\s*0([.,]00)?$/i.test(text)) return 0;
  return parseMoney(text);
};

export const normalizeAliShippingOption = (option = {}) => {
  const fee = parseShippingFee(option.shipping_fee_format || option.shipping_fee || option.freight_amount);
  const method = option.company || option.service_name || option.delivery_company || 'AliExpress Shipping';
  const minDays = option.min_delivery_days;
  const maxDays = option.max_delivery_days;
  const eta = option.delivery_date_desc || (minDays || maxDays ? `${minDays || '?'}-${maxDays || '?'} days` : '');
  return {
    ...option,
    method,
    fee,
    eta,
    label: `${method}${eta ? ` • ${eta}` : ''}`,
  };
};

export const findCheapestShippingOption = (options = []) => {
  const normalized = (Array.isArray(options) ? options : [])
    .map(normalizeAliShippingOption)
    .sort((a, b) => a.fee - b.fee);
  return normalized[0] || null;
};
